import { useContext } from 'react';
import { UserContext } from '../../contexts/user/UserContext';

export default function useUser() {
  return useContext(UserContext);
}
